export default __webpack_public_path__ + "static/media/14.0aaacd8c.jpeg";